module.exports = __webpack_public_path__ + "static/media/14.53d302ae.png";